// @flow

// Sagas
import boot from './boot'
// Effect Managers
import { fork } from 'redux-saga/effects'

export default function *authMain (): Generator<*, void, *> {
  yield fork(boot)
}
